import { addDays } from 'date-fns/addDays';
import { startOfDay } from 'date-fns/startOfDay';
import type { DateRepresentation } from './DateRepresentation';
import { defaultTimeZone } from './defaultTimeZone';
import { localTimeOperation } from './localTimeOperation';

export function startOfDayInTZ(date?: DateRepresentation, timeZone: string = defaultTimeZone): Date | undefined {
	return localTimeOperation(date ?? new Date(), startOfDay, timeZone);
}

export function startOfDayEST(date?: DateRepresentation): Date | undefined {
	return startOfDayInTZ(date, 'America/New_York');
}

export function startOfNextDayInTZ(date?: DateRepresentation, timeZone: string = defaultTimeZone): Date | undefined {
	const currentDay = startOfDayInTZ(date, timeZone);
	if (!currentDay) {
		return undefined;
	}

	const nextDay = addDays(currentDay, 1);
	return startOfDayInTZ(nextDay, timeZone);
}

export function startOfNextDayEST(date?: DateRepresentation): Date | undefined {
	return startOfNextDayInTZ(date, 'America/New_York');
}
